/* ============
 * Mutation types for the resolve module
 * ============
 *
 * The mutation types that are available
 * on the resolve module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_RESOLVE_ACTIONS: null,
  FETCH_RESOLVE_ACTIONS_SUCCESS: null,
  FETCH_RESOLVE_ACTIONS_FAIL: null
});
